const PLAN_LINE_PREFIX = /^\s*\d+\.\s*/;

export const emptyCorrectiveAction = (ordre = 1) => ({
  action_corrective: "",
  avancement: "",
  date_debut: "",
  date_fin: "",
  deletionLocked: false,
  indicateur_efficacite: "",
  isEditing: true,
  ordre,
  plan_action: "",
  plan_action_id: null,
  responsable_ids: [],
  responsables: [],
  status: null,
  validated: false,
});

export const stripPlanLinePrefix = (line) =>
  String(line || "").replace(PLAN_LINE_PREFIX, "");

export const hasPlanContent = (value) =>
  String(value || "")
    .split("\n")
    .some((line) => stripPlanLinePrefix(line).trim());

export const normalizePlanAction = (value, selectionStart = 0) => {
  const rawValue = String(value || "");
  const contentLines = rawValue.split("\n").map(stripPlanLinePrefix);

  if (!contentLines.some((line) => line.trim())) {
    return { cursor: 0, value: "" };
  }

  const beforeLines = rawValue.slice(0, selectionStart).split("\n");
  const cursorLineIndex = beforeLines.length - 1;
  const cursorContent = stripPlanLinePrefix(
    beforeLines[cursorLineIndex] || ""
  );
  const numberedLines = contentLines.map(
    (line, index) => `${index + 1}. ${line}`
  );
  const previousLength = numberedLines
    .slice(0, cursorLineIndex)
    .reduce((total, line) => total + line.length + 1, 0);

  return {
    cursor:
      previousLength + `${cursorLineIndex + 1}. `.length + cursorContent.length,
    value: numberedLines.join("\n"),
  };
};

export const daysBetween = (startValue, endValue) => {
  if (!startValue || !endValue) return "";
  const start = new Date(`${startValue}T00:00:00`);
  const end = new Date(`${endValue}T00:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return "";
  return Math.ceil((end.getTime() - start.getTime()) / 86400000);
};

export const validateCorrectiveAction = (action) => {
  const errors = {};
  const requiredTextFields = [
    "action_corrective",
    "indicateur_efficacite",
    "avancement",
    "date_debut",
    "date_fin",
  ];

  requiredTextFields.forEach((field) => {
    if (!String(action?.[field] ?? "").trim()) errors[field] = "Obligatoire.";
  });
  if (!hasPlanContent(action?.plan_action)) {
    errors.plan_action = "Obligatoire.";
  }
  if (
    !Array.isArray(action?.responsable_ids) ||
    action.responsable_ids.length === 0
  ) {
    errors.responsable_ids = "Sélectionnez au moins un responsable.";
  }

  const progress = Number(action?.avancement);
  if (
    String(action?.avancement ?? "").trim() &&
    (!Number.isFinite(progress) || progress < 0 || progress > 100)
  ) {
    errors.avancement = "La valeur doit être comprise entre 0 et 100.";
  }

  if (
    action?.date_debut &&
    action?.date_fin &&
    daysBetween(action.date_debut, action.date_fin) < 0
  ) {
    errors.date_fin = "La date de fin doit être postérieure à la date de début.";
  }

  return errors;
};

export const userMetaLabel = (user) =>
  [user?.functionName, user?.directionCode]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(" — ");
